import * as React from 'react';

import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import type { VariantProps } from 'class-variance-authority';
import { Label as LabelPrimitive } from 'radix-ui';

function Label({
  className,
  disabled,
  readonly,
  variant,
  color,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & {
  disabled?: boolean;
  readonly?: boolean;
} & VariantProps<typeof typographyVariants>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        typographyVariants({ ...props, color, variant }),
        'flex items-center gap-1 select-none',
        disabled && typographyVariants({ color: 'disabled' }),
        readonly && typographyVariants({ color: 'secondary' }),
        className,
      )}
      {...props}
    />
  );
}

export { Label };
